module.exports = __webpack_public_path__ + "media/images/emblems/Caslano-coat_of_arms-ef83f3863823419bbce28b47b85e6896.svg";